import React, { useRef, useState } from 'react';
import VideoCard from './VideoCard';
import './VideoCarousel.css';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

export default function VideoCarousel({ title, videos, sectionId }) {
	const cardCarouselRef = useRef(null);
	const [playingVideo, setPlayingVideo] = useState(null);

	const handlePlayPause = (index) => {
		setPlayingVideo(index);
	};

	const scrollRight = () => {
		if (cardCarouselRef.current) {
			cardCarouselRef.current.scrollLeft += 320;
		}
	};

	const scrollLeft = () => {
		if (cardCarouselRef.current) {
			cardCarouselRef.current.scrollLeft -= 320;
		}
	};

	return (
		<section className='video-carousel-section'>
			<div className='header-container'>
				<h2>{title}</h2>
				<div className='scroll-btns'>
					<button className='scroll-btn' onClick={scrollLeft}>
						<KeyboardArrowLeftIcon fontSize='large' className='scroll-icon' />
					</button>
					<button className='scroll-btn' onClick={scrollRight}>
						<KeyboardArrowRightIcon fontSize='large' className='scroll-icon' />
					</button>
				</div>
			</div>

			<div className='card-carousel' ref={cardCarouselRef}>
				{videos.map((video, i) => (
					<VideoCard
						key={`${sectionId}-${i}`}
						video={video}
						index={i}
						isPlaying={playingVideo === i}
						onPlayPause={handlePlayPause}
					/>
				))}
			</div>
		</section>
	);
}
